import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import ShowProjectSlice from "../slices/ShowProjectSlice";
import { RootState } from "../store";

export const ShowProjectActions = ShowProjectSlice.actions;
export const setShowProjectAction = (showProject: boolean): ThunkAction<void, RootState, unknown, AnyAction> => {
    return async (dispatch, getState) => {
            dispatch(ShowProjectActions.setShowProjectSlice(showProject));
    }
}